import React, { useState, useEffect } from "react";
import { FaRocket, FaGlobe, FaSearch, FaBolt, FaPlug, FaShieldAlt, FaCheck } from "react-icons/fa";
import Nav from "../Nav";
import "../ProjectTemplate.css";

const ExampleProj4Page = () => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <div className="app">
      <Nav theme={theme} setTheme={setTheme} />
      <div className="project-wrap">
        <div className="project-hero-card">
          <h1>Example Project 4</h1>
          <p className="project-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p className="project-blurb">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Project Architecture</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-card-full">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.
            </p>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Core Scanning Capabilities</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-grid">
            <div className="project-card">
              <h3><FaRocket /> Feature One</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
              </p>
            </div>
            <div className="project-card">
              <h3><FaGlobe /> Feature Two</h3>
              <p>
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non.
              </p>
            </div>
            <div className="project-card">
              <h3><FaSearch /> Feature Three</h3>
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.
              </p>
            </div>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Interface &amp; Workflow</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-two-col">
            <div className="col">
              <p>
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi.
              </p>
              <p>
                Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
              </p>
            </div>
            <div className="col col-highlight">
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 10px" }}>Key Interface Details</h3>
              <ul className="project-list">
                <li><span>Point One</span><FaCheck style={{color: "var(--brand)"}} /></li>
                <li><span>Point Two</span><FaCheck style={{color: "var(--brand)"}} /></li>
                <li><span>Point Three</span><FaCheck style={{color: "var(--brand)"}} /></li>
                <li><span>Point Four</span><FaCheck style={{color: "var(--brand)"}} /></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Technical Highlights</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-grid">
            <div className="project-card">
              <h3><FaBolt /> Feature Four</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
            <div className="project-card">
              <h3><FaPlug /> Feature Five</h3>
              <p>
                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
            <div className="project-card">
              <h3><FaShieldAlt /> Feature Six</h3>
              <p>
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="project-footer">
        <p>&copy; {new Date().getFullYear()} Nameless</p>
        <a href="#" onClick={(e) => e.preventDefault()}>email@example.com</a>
      </footer>
    </div>
  );
};

export default ExampleProj4Page;
